import React from 'react';
import { createRoot } from 'react-dom/client';
import Quiz from './quiz';

export default (element, data) => {
  const init = () => {
    const root = createRoot(element);
    root.render(<Quiz {...data} />);
  };

  init();
};
